module.exports = __webpack_public_path__ + "media/bgm.a8e11211.mp3";